/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Y_Offset_LabelInputs */



/**
* | output |
* | --- |
* | "Vertical (Y) Offset" |
*
* @param {Style_Guide_Manager_Position_Y_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_y_offset_label = /** @type {((inputs?: Style_Guide_Manager_Position_Y_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Y_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decalage vertical (Y)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertikaler (Y)-Versatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset verticale (Y)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вертикальное (Y) смещение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento vertical (Y)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("垂直 (Y) 偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("垂直（Y）オフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊर्ध्वाधर (Y) ऑफ़सेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento vertical (Y)")
	return /** @type {LocalizedString} */ ("Vertical (Y) Offset")
});